import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  isModalOpen: false,
  type: 'create',
  surveyId: null
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
